/* oxlint-disable react/jsx-props-no-spreading -- props are intentionally forwarded by this adapter */
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'
import { EditPencil } from 'iconoir-react'
import { ChangeEvent, useEffect, useState } from 'react'
import { Modal } from '../Modal'

// const sortColumnsAlphabetically = (columns: Column<any, unknown>[]) =>
//   sortBy(columns, (column) => column.columnDef.header?.toString().toLowerCase())

export default function FormStringArrayModal({
  options,
  defaultOptions,
  title,
  onChange,
}: {
  options: string[]
  defaultOptions: string[]
  title: string
  onChange: (options: string[]) => void
}): React.ReactElement {
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [searchValue, setSearchValue] = useState(``)
  const [filteredOptions, setFilteredOptions] = useState(options)
  const [selectedOptions, setSelectedOptions] = useState(defaultOptions)

  const onRemove = (option: string) => {
    setSelectedOptions((prev) => {
      if (prev.includes(option)) {
        return prev.filter((o) => o !== option)
      }
      return [...prev]
    })
  }
  const handleApplyClick = async () => {
    setOpenDialog(false)
    onChange(selectedOptions)
  }

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value)
  }

  const onToggleOption = (option: string) => {
    setSelectedOptions((prev) => {
      if (prev.includes(option)) {
        return prev.filter((o) => o !== option)
      }
      return [...prev, option]
    })
  }

  useEffect(() => {
    setFilteredOptions(options.filter((option) => option.toLowerCase().includes(searchValue.toLowerCase())))
  }, [searchValue, options])

  return (
    <>
      <div className="flex w-44 flex-col gap-1.5">
        <p className="text-label-sm text-default">{title}</p>
        <button type="button" className="btn btn-tertiary btn-lg justify-between" onClick={() => setOpenDialog(true)}>
          <div className="text-body-sm text-default">{`(${selectedOptions.length}) selected`}</div>
          <EditPencil className="h-4 w-4" />
        </button>
      </div>
      {/* eslint-disable-next-line deprecation/deprecation */}
      <Modal
        title={title}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false)
          setSearchValue(``)
        }}
        isFullScreen={false}
        showActions={true}
        removePadding={true}
        actionLabel="Save"
        onActionTriggered={handleApplyClick}
      >
        <div className="flex h-[80vh] w-[1024px]">
          <div className="w-1/2 border-r border-default">
            <div className="relative">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <MagnifyingGlassIcon className="h-6 w-6 text-default" aria-hidden="true" />
              </div>
              <input
                className="h-11 w-full border-b border-default bg-surface py-3 pl-11 text-body-sm text-strong outline-none"
                placeholder="Search..."
                value={searchValue}
                onChange={handleSearch}
              />
            </div>
            <div className="h-[90%] overflow-y-auto">
              {filteredOptions.map((option) => {
                return (
                  <div key={option} className="py-2 pl-8">
                    <label className="mb-0 flex cursor-pointer items-center">
                      <input
                        {...{
                          type: `checkbox`,
                          checked: selectedOptions.includes(option),
                          onChange: () => onToggleOption(option),
                          className: `mr-2 cursor-pointer fill-current text-default rounded-sm h-4 w-4 disabled:cursor-not-allowed disabled:bg-surface-subtle disabled:text-subtle disabled:bg-current`,
                        }}
                      />
                      <div className="text-body-sm text-default">{option}</div>
                    </label>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="w-1/2 overflow-y-auto bg-surface-subtle py-3 pl-3.5 pr-4">
            <div className="text-ui-sm text-strong">Selected</div>
            <div className="mt-3 flex flex-col space-y-2">
              {selectedOptions?.map((item, i) => {
                return (
                  <div
                    className={classNames(
                      `flex h-9 items-center justify-between rounded-md bg-surface px-2 shadow-elevation-1`,
                    )}
                    key={i}
                  >
                    <div className="flex items-center overflow-hidden">
                      <div className="ml-2 mr-6 overflow-hidden text-ellipsis whitespace-nowrap text-body-sm text-default">
                        {item}
                      </div>
                    </div>

                    <XMarkIcon
                      onClick={() => onRemove(item)}
                      className="h-5 w-5 shrink-0 cursor-pointer fill-current text-default"
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
